// import "babel-polyfill";
// import cssVars from "css-vars-ponyfill";

import React from 'react'
// import ReactDOM from 'react-dom'
import { createRoot } from 'react-dom/client'
// import * as serviceWorker from './serviceWorker'
import App from './app/App'
import reportWebVitals from './reportWebVitals';
import 'globals.css';

// const root = ReactDOM.createRoot(document.getElementById('root'));
const root = createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// serviceWorker.unregister()
